export enum OrderApplicationStatus {
  None = "none",
  DraftGeneral = "draftGeneral",
  DraftParticipant = "draftParticipant",
  DraftPayment = "draftPayment",
  DraftCreated = "draftCreated",
}
